import { render, staticRenderFns } from "./perCert.vue?vue&type=template&id=0f810ffc"
import script from "./perCert.vue?vue&type=script&lang=js"
export * from "./perCert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports